import { User } from "@easycv/common/types/user";
import ucla_data_summary from "./ucla_data_summary";

export { default as ucla_data_summary } from "./ucla_data_summary";

export default {
  title: "UCLA Data Summary Professor",
  tabTitle: "Data Summary Professor",
  cvSetup: function ({
    contextMethods,
    contextConstants,
    contextState,
    conference,
    backend
  }) {
    const professorVersion = true;
    ucla_data_summary.cvSetup({
      contextMethods,
      contextConstants,
      contextState,
      conference,
      backend,
      professorVersion
    });
  },

  manageSetup: function (
    settingsEl: JQuery,
    { conference, updateConfDate, saveConference, hierarchyNames },
    user: User
  ) {
    ucla_data_summary.manageSetup(
      settingsEl,
      { conference, updateConfDate, saveConference, hierarchyNames },
      user
    );
  }
};
